import settings from '../settings.js'

const $inject = ['$scope', '$stateParams', '$sce', '$ionicPopup', '$interval', 'common', '$state', 'FitnessService', 'UserService', '$compile']

function FitnessCtrl(scope, stateParams, sce, ionicPopup, interval, common, state, FitnessService, UserService, compile) {
    scope.baseUrl = settings.baseUrl;
    scope.appRootDir = appRootDir;

    scope.initDoneLast = false; //This becomes Moment after init has been done atleast once
    scope.initLastLangCode = null;

    scope.settings = settings;

    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    scope.FitnessService = FitnessService.fitnessAPI();

    scope.calendarPopup = null;
    scope.calendarPopupResolve = null;

    scope.searchDateBar = [];
    scope.pageContent = [];
    scope.fullPageContent = [];

    scope.showOwnedEventsOnly = false;

    scope.selectedSearchDate = {
        moment: null,
        dayFormat: null,
        dayName: null
    };
    
    //Set all search values
    scope.setSearchDateValues = (moment, dayFormat, dayName) => {
        scope.selectedSearchDate.moment = !!moment ? moment : null;
        scope.selectedSearchDate.dayFormat = !!dayFormat ? dayFormat : null;
        scope.selectedSearchDate.dayName = !!dayName ? dayName : null;
    };

    scope.slider = null;

    scope.slideInit = (slider) => {
        scope.slider = slider;

        if (stateParams.fitnessCategoryId && FitnessService.fitnessCategories) {
            const fitnessIndex = FitnessService.fitnessCategories.findIndex((loopCategory) => loopCategory.eventCategoryId === parseInt(stateParams.fitnessCategoryId));

            if (fitnessIndex > -1 && scope.slider.activeIndex !== fitnessIndex)
                scope.slider.slideTo(fitnessIndex, 0);

            stateParams.fitnessCategoryId = null;
        }
    };

    scope.sliderOptions = {
        effect: 'slide',
        autoHeight: false,
        initialSlide: 0,
        onInit: scope.slideInit
    };

    scope.initContentInProgress = false;

    //Create html for all categories
    scope.initContentPages = (isRefresh = false) => {
        console.log("[" + performance.now() + "] initContentPages function start. isRefresh = " + isRefresh);

        return new Promise((resolve, reject) => {
            //Retain current search date (or lack of one) if we are doing refresh only. Otherwise set to current date.
            if (!isRefresh) {
                //Set language being used for this init.
                scope.initLastLangCode = UserService.langCode;

                if (settings.fitnessDefaultShowAll) {
                    scope.setSearchDateValues();
                }
                else {
                    const searchDateMoment = moment();

                    if (UserService.langCode === 'en-GB') {
                        searchDateMoment.locale('en');
                        scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), 'on ' + searchDateMoment.format('dddd').ucfirst());
                    }
                    else if (UserService.langCode === 'sv-SE') {
                        searchDateMoment.locale('sv');
                        scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), 'på ' + searchDateMoment.format('dddd').ucfirst());
                    }
                    else if (UserService.langCode === 'de-DE') {
                        searchDateMoment.locale('de');
                        scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), ' ' + searchDateMoment.format('dddd').ucfirst());
                    }                    
                    else {
                        searchDateMoment.locale('fi');
                        scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), searchDateMoment.format('dddd').ucfirst() + 'na');
                    }
                }

                console.log(FitnessService.fitnessCategories);
			}

            if (FitnessService.fitnessCategories.length) {
                for (let index of FitnessService.fitnessCategories.keys()) {
                    scope.$evalAsync(() => {
                        scope.pageContent[index] = scope.createContent(index, false);
                        scope.fullPageContent[index] = scope.createContent(index, true); //Skip date comp
                    });            
                };

                scope.initDoneLast = moment();
            }
            else {
                console.log("ERROR: initContentPages ran with no fitnessCategories!");
            }

            resolve(true);
        });
    };

    const doFitnessInit = (isRefresh = false) => {
        scope.FitnessService = FitnessService.fitnessAPI(); //Template won't work if I don't do this...

        if (!FitnessService.fitnessCategories.length)
            return false;
        
        scope.initContentInProgress = true;

        scope.initContentPages(isRefresh).then(() => {
            console.log(`[${performance.now()}] initContentPages then done.`);
            scope.initContentInProgress = false;
        });
    };

    //If we require login, but not logged in, go back to front
    if ((settings.fitnessRequiresLogin && UserService.loginData.loginState !== 2) || !settings.fitnessEnabled)
        state.go(settings.stateFront);

    //Do init on AppCtrl ready (if not yet done), if we are already on app.fitness and cannot rely on beforeEnter
    //Primarily required for forced refresh on app.fitness in PWA.
    scope.$on('appCtrl:fitnessReady', () => {
        if (!scope.initDoneLast) 
            doFitnessInit(false); //Not refresh
    });

    //Redo init when user logins. 
    scope.$on('User:loggedIn', () => {
        doFitnessInit(false); //Not refresh
    });

    //Redo init when access validity changes
    scope.$on('User:accessValidChanged', () => {
        doFitnessInit(false); //Not refresh
    });

    //Called from interval and beforeEnter event
    const eventsUpdate = (forceRefresh = false, skipServerUpdate = false) => {
        const minuteDiff = moment.isMoment(scope.initDoneLast) ? moment().diff(scope.initDoneLast, 'minutes') : false; //How many minutes since last update?
        const dayChanged = moment.isMoment(scope.initDoneLast) ? moment().day() !== scope.initDoneLast.day() : false; //Has day has changed since last update?
        const langChanged = (scope.initLastLangCode && scope.initLastLangCode !== UserService.langCode) ? true : false; //Has language changed since last update?

        //If day or language has changed, we need to also remake the searchbar!
        if (dayChanged || langChanged) 
            scope.searchDateBar = [];

        //Do full init on first entry or when it has been >= than (settings.fitnessEventsRefreshIntervalMinutes) minutes since last full init or when day has changed since last full init or when language has changed.
        //Also do init if we are forcing refresh. This is done if we have changed fitnessEvents programmatically.
        if (!scope.initDoneLast || minuteDiff >= settings.fitnessEventsRefreshIntervalMinutes || dayChanged || langChanged || forceRefresh) {
            const isRefresh = !langChanged && !dayChanged && !!scope.initDoneLast && !forceRefresh;

            if (!scope.initDoneLast || skipServerUpdate) {
                //For first init, don't get fitness events again. Slows down too much. Don't call if we are skipping server update
                doFitnessInit(isRefresh); //Set isRefresh if we are dealing with changed date/time update only
            }
            else {
                //Get new data first, if doing refresh
                console.log(`[${performance.now()}] Calling FitnessService.getFitnessData() from eventsUpdate()`);

                FitnessService.getFitnessData().then(() => {
                    doFitnessInit(isRefresh); //Set isRefresh if we are dealing with changed date/time update only
                });
            }

            return true;
        }

        return false;
    };

    scope.$on('language.changed', (event, newLangCode) => {
        eventsUpdate();
    });

    scope.$on('fitness.doRefresh', (event, skipServerUpdate) => {
        eventsUpdate(true, skipServerUpdate);
    });

    //Handle (un)registered attendee quantity change. Try to speed things up by recreating only pages 'all' and the changed category page
    //Also do initContentPages on start, and after 60 min/day change
    scope.$on('$ionicView.beforeEnter', () => {
        //Run doFitnessInit() if necessary
        if (eventsUpdate())
            return true;

        //Otherwise check for actual changes, and if so redo ONLY pages 'all' and category matching changed event
        if (!FitnessService.changedFitnessEventActivityId || scope.slider === null)
            return true;

        let changedCategoryIndex = scope.slider.activeIndex;

        if (changedCategoryIndex === 0) { //If active index is 0 (all), find the category index that contains the changed activity                
            const changedEvent = FitnessService.fitnessEvents.find((event) => event.activityId === FitnessService.changedFitnessEventActivityId);

            if (changedEvent)
                changedCategoryIndex = FitnessService.fitnessCategories.findIndex((categ) => categ.eventCategoryId === changedEvent.eventCategoryId);
        }

        FitnessService.changedFitnessEventActivityId = false;

        scope.$evalAsync(() => {
            //Recreate 'all' page
            scope.pageContent[0] = scope.createContent(0, scope.showOwnedEventsOnly); 
            scope.fullPageContent[0] = scope.createContent(0, true); //Skip date comp

            //Recreate page matching changed event category
            if (changedCategoryIndex) {
                scope.pageContent[changedCategoryIndex] = scope.createContent(changedCategoryIndex, scope.showOwnedEventsOnly);
                scope.fullPageContent[changedCategoryIndex] = scope.createContent(changedCategoryIndex, true); //Skip date comp
            }
        });
    });

    //Create pages here. 
    scope.createContent = (slideCategoryIndex, skipDateComparison) => {
        const slideEventCategoryId = FitnessService.fitnessCategories[slideCategoryIndex].eventCategoryId;

        let returnPage = "",
            eventCount = 0;

        if (!scope.searchDateBar.length) { //If empty, searchbar array not made yet (or emptied for remaking due to lang/other change).
            for (let I = 0; I < 7; I++) {
                const barDateMoment = moment().clone().add(I, 'days');

                if (UserService.langCode === 'en-GB') {
                    barDateMoment.locale('en');
                }
                else if (UserService.langCode === 'sv-SE') {
                    barDateMoment.locale('sv');
                }
                else if (UserService.langCode === 'de-DE') {
                    barDateMoment.locale('de');
                }                
                else {
                    barDateMoment.locale('fi');
                }

                scope.searchDateBar.push({
                    moment: barDateMoment.clone(),
                    dayNum: barDateMoment.format('DD'),
                    dayName: barDateMoment.format('dd').ucfirst()
                });
            }
        }

        returnPage += `<div class="wrap">`;

        if (scope.searchDateBar.length) {
            scope.searchDateBar.forEach((date, index) => {
                const isSearchDate = !skipDateComparison && (scope.selectedSearchDate.moment !== null && date.moment.isSame(scope.selectedSearchDate.moment, 'day'));
                
                returnPage += `
                    <div ng-click="eventDatePicker(${isSearchDate ? 'true' : '\'' + date.moment.format('DD.MM.YYYY') + '\'' })" class="dateBox ${isSearchDate ? 'selectedDate' : 'unselectedDate'}">
                        <span class="dayname">${date.dayName}</span><br>
                        <span class="daynumber">${date.dayNum}</span>
                    </div>`;
            });
        }

        let hasValidAccess = false;

        //Check if user has any valid access rights. Now or in future
        if (common.validUntilArray) {
            hasValidAccess = Object.values(common.validUntilArray).some((tmpValid) => tmpValid.some((validity) => {
                return (validity.validTo === null || moment(validity.validTo).isSameOrAfter(moment()));
            }));
        }

        returnPage += `
            <div class="dateBox" ng-click="eventDatePicker(false)">                    
                <span class="dayname">{{ 'day' | wnTranslate:true }}</span><br>
                    <span class="dayicon"><span class="ion-ios-calendar-outline"></span>
                </span>                    
            </div>

            <div class="dateBox" ng-click="showOwnedEvents()">                    
                <span class="dayname ng-binding">{{ 'owned' | wnTranslate:true }}</span><br>
                    <span class="dayicon"><span class="icon ion-ios-contact ${scope.showOwnedEventsOnly ? 'selectedIcon' : ''}"></span>
                </span>                    
            </div>
            
            <div class="erasedate" ng-click="resetSearchFields()">{{ 'remove selections' | wnTranslate:true }} <span class="ion-ios-trash-outline"></span></div>
            <div class="wholedate">${ !skipDateComparison && moment.isMoment(scope.selectedSearchDate.moment) ? scope.selectedSearchDate.dayName : "{{ 'all days' | wnTranslate:true }}" } ${ !skipDateComparison && moment.isMoment(scope.selectedSearchDate.moment) ? scope.selectedSearchDate.dayFormat : '' }</div>
        </div>`;

        //List all fitness events.
        if (FitnessService.fitnessEvents.length) {
            for (let event of FitnessService.fitnessEvents) {
                let attendanceStatus = FitnessService.getFitnessStatus(event);

                if (scope.showOwnedEventsOnly && attendanceStatus === 0)
                    continue;

                if (slideEventCategoryId !== -1 && slideEventCategoryId !== event.eventCategoryId)
                    continue;

                const activityStartTime = moment(event.activityStartTime, 'DD.MM.YYYY HH:mm');
                const activityEndTime = moment(event.activityEndTime, 'DD.MM.YYYY HH:mm');

                const showBeforeMinute = settings.eventEnroll.stopBeforeMinutes < 0 ? Math.abs(settings.eventEnroll.stopBeforeMinutes) : 0;

                const cannotEnrollAnymore = activityStartTime.isBefore(moment().subtract(showBeforeMinute, 'minute') , 'minute');

                //Check if the event has started. If event has not yet started, show it
                let showActivity = moment().isBefore(activityStartTime.add(showBeforeMinute, 'minute'), 'minute');

                //If event has started, but we are admin and event started less than fitnessShowPastEventsToAdmin amount type ago, show it. 
                if (!showActivity && UserService.loginData.loginState === 2 && FitnessService.hasEventListPermission) {
                    showActivity = moment().subtract(settings.fitnessShowPastEventsToAdmin.value, settings.fitnessShowPastEventsToAdmin.type).isBefore(activityStartTime, 'minute');
                }

                //For some categories we check the activityEndTime instead of start.
                const canEnrollUntilEnd = (settings.enrollUntilEndCategoryId && event.eventCategoryId === settings.enrollUntilEndCategoryId);

                //If event has started and we are not admin, but we are dealing with special category (lapsiparkki), show it so long as the event has not actually ended.
                if (!showActivity && canEnrollUntilEnd) {
                    showActivity = moment().isBefore(activityEndTime, 'minute');
                }

                if (showActivity && (skipDateComparison || !scope.selectedSearchDate.moment || moment(scope.selectedSearchDate.moment).isSame(activityStartTime, 'day'))) {
                    //Set class and possibly style
                    let eventClass,
                        eventStyleBorder = '',
                        eventStyleText = '';

                    if (cannotEnrollAnymore && (!canEnrollUntilEnd || moment().isAfter(activityEndTime, 'minute'))) { //If we cannot enroll anymore, use eventDisabled class. Note that this is shown only to those with acl permission
                        eventClass = 'eventDisabled';
                    }
                    else if (attendanceStatus === 1) { //Show light green if enrolled
                        eventClass = 'eventAttendance';
                    }
                    else if (attendanceStatus === 2) { //Show slightly darker green if enrolled and registered
                        eventClass = 'eventRegistered';
                    }
                    else if (attendanceStatus === 3) { //Show light blue if currently in queue
                        eventClass = 'eventQueued';
                    }
                    else if (event.totalCapacity === -1 || event.totalAttendeeQuantity >= event.totalCapacity && event.totalCapacity !== 0) { //If event is full, show eventFull class
                        eventClass = 'eventFull';
                    }
                    else { //Otherwise use default eventNormal class
                        eventClass = 'eventNormal';

                        //If event category has color set, change bottom border color, name color and capacity color to match it
                        if (event.categoryColor) {
                            eventStyleBorder = 'style="border-bottom: 12px solid ' + event.categoryColor + ';"';
                            eventStyleText = 'style="color: ' + event.categoryColor + ';"';
                        }
                    }

                    returnPage += `
                        <div class="event" ng-click="clickedEvent(${ event.activityId })">
                            <div class="spacer" style="height: 15px;"></div>
                            <div class="fitness-event ${ (!settings.fitnessHideCapacityForNonMember || hasValidAccess || FitnessService.hasEventListPermission) ? eventClass : '' }" ${ eventStyleBorder }>
                                <div class="icon">
                                    ${event.imageId ? '<img ng-src="' + settings.baseUrl + '?action=getContent&type=image&id=' + event.imageId + '">' : '&nbsp;'}
                                </div>
                                <div class="name" ${ eventStyleText }>
                                    ${ event.name }
                                </div>
                                <div class="place" ng-if="${ (event.address || event.venue) ? 'true' : 'false' }">
                                    ${ (event.address ? '<span class="spanPlace">' + event.address + (event.venue ? ', ' : '') + '</span>' : '') } <span class="spanVenue">${ event.venue }</span>
                                </div>
                                <div class="trainer">
                                    ${ event.activityDisplayPersons ? event.activityDisplayPersons : '&nbsp;' }
                                </div>
                                <div ng-if="${ (!settings.fitnessHideCapacityForNonAdmin || FitnessService.hasEventListPermission) && (!settings.fitnessHideCapacityForNonMember || hasValidAccess) ? 'true' : 'false' }" class="capacity" ${ eventStyleText }>
                                    ${ event.totalCapacity !== -1 ? (event.totalAttendeeQuantity + (event.totalQueueQuantity ? ' (' + event.totalQueueQuantity + ')' : '') + " / " + (event.totalCapacity !== 0 ? event.totalCapacity : '&infin;')) : '' }
                                </div>
                                <div class="date">
                                    ${ FitnessService.getTimeDisplayFormat(event) }
                                </div>
                            </div>
                        </div>`;

                    eventCount++;
                }
            }
        }

        if (!FitnessService.categoriesLoaded || !FitnessService.eventsLoaded || !eventCount) {
            returnPage += `
            <div class="result">
                <span class="ion-ios-albums-outline"></span><br>{{ (showOwnedEventsOnly ? 'no owned events' : (settings.fitnessEmptyText || 'no events')) | wnTranslate:true }}
            </div>`;
        }
        else {
            returnPage += `<div class="spacer" style="height: 15px;"></div>`;
        }

        return sce.trustAsHtml(returnPage);
    };   

	//Jumppakalenteri only
    scope.$on('Fitness:reset', () => {
        if (settings.fitnessDefaultShowAll) {
            scope.setSearchDateValues();
        }
        else {
            const searchDateMoment = moment();

            if (UserService.langCode === 'en-GB') {
                searchDateMoment.locale('en');
                scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), 'on ' + searchDateMoment.format('dddd').ucfirst());
            }
            else if (UserService.langCode === 'sv-SE') {
                searchDateMoment.locale('sv');
                scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), 'på ' + searchDateMoment.format('dddd').ucfirst());
            }
            else if (UserService.langCode === 'de-DE') {
                searchDateMoment.locale('de');
                scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), searchDateMoment.format('dddd').ucfirst());
            }            
            else {
                searchDateMoment.locale('fi');
                scope.setSearchDateValues(searchDateMoment, searchDateMoment.format('L'), searchDateMoment.format('dddd').ucfirst() + 'na');
            }
        }

        if (FitnessService.fitnessCategories.length) {
            FitnessService.fitnessCategories.forEach((date, index) => {
                scope.$evalAsync(() => {
                    scope.pageContent[index] = scope.createContent(index, false);
                    scope.fullPageContent[index] = scope.createContent(index, true);
                });            
            });
        }

        if (scope.slider)
            scope.slider.slideTo(0, 0);
    });

    scope.resetSearchFields = () => {
        scope.setSearchDateValues();

        if (scope.showOwnedEventsOnly) {
            scope.showOwnedEventsOnly = false;

            if (FitnessService.fitnessCategories.length) {
                for (let index of FitnessService.fitnessCategories.keys()) {
                    scope.fullPageContent[index] = scope.createContent(index, false); //Skip date comp
                }
            }
        }

        scope.$evalAsync(() => {
            scope.pageContent = angular.copy(scope.fullPageContent);
        });
        
        scope.slider.slideTo(0, 0);
    };

    scope.eventDatePicker = (dateInput) => {
        //TODO: Remove plugin usage. Turn into directive at some point.

        const disableshowOwnedEvents = () => {
            //If we previously only showed own events, we need to remake full page contents for all events
            if (scope.showOwnedEventsOnly) {
                scope.showOwnedEventsOnly = false;

                if (FitnessService.fitnessCategories.length) {
                    for (let index of FitnessService.fitnessCategories.keys()) {
                        scope.fullPageContent[index] = scope.createContent(index, true); //Skip date comp
                    }
                }
            }
        };

        const datePickeroptions = {
            mode: 'date',
            date: new Date(),            
            todayText: _locale('today').ucfirst(),
            allowOldDates: true,
            allowFutureDates: true,
            androidTheme: 5,
            doneButtonLabel: 'OK',
            doneButtonColor: '#000000',
            cancelButtonLabel: _locale('cancel').ucfirst(),
            cancelButtonColor: '#000000'
        };

        if (moment.isMoment(scope.selectedSearchDate.moment))
            datePickeroptions.date = scope.selectedSearchDate.moment.toDate();

        const openPopupCalendar = () => {
            return new Promise((resolve, reject) => {
                const customTemplate = `<ion-content style="background-color: #fff;"><responsive-calendar></responsive-calendar></ion-content>`;

                scope.calendarPopupResolve = resolve;

                scope.deregisterListener = scope.$on('User:loggedOut', () => {
                    if (scope.calendarPopup)
                        scope.calendarPopup.close();
                });

                scope.calendarDays = [];

                const tmpMoment = moment();

                if (UserService.langCode === 'en-GB') {
                    tmpMoment.locale('en');
                }
                else if (UserService.langCode === 'sv-SE') {
                    tmpMoment.locale('sv');
                }
                else if (UserService.langCode === 'de-DE') {
                    tmpMoment.locale('de');
                }                
                else {
                    tmpMoment.locale('fi');
                }

                for (let I = 0; I < 7; I++) {
                    scope.calendarDays[I] = tmpMoment.isoWeekday(I + 1).format('dd').ucfirst();
                }

                scope.calendarPopup = ionicPopup.show({
                    template: (compile(customTemplate)(scope)).html(), //Compile before popup.
                    title: _locale('select date').ucfirst(),
                    cssClass: 'popupCalendar',
                    scope: scope,
                    buttons: [{
                        text: _locale('cancel').ucfirst(),
                        onTap: (e) => {
                            scope.deregisterListener();
                            resolve(false);                            
                        } 
                    }]
                });
            });
        };

        const handleInputMoment = (pickedDate) => {
            if (!moment.isMoment(pickedDate))
                pickedDate = moment(pickedDate, "DD.MM.YYYY");

            if (pickedDate.isBefore(moment(), 'day')) {
                const popupPromise = ionicPopup.alert({
                    title: _locale('date error').ucfirst(),
                    template: _locale('you cannot select past dates').ucfirst(),
                    cssClass: 'bigger-popup'
                });

                popupPromise.then(() => {
                    openPopupCalendar().then((res) => {
                        if (res)
                            handleInputMoment(res);
    
                        scope.calendarPopupResolve = null;
                        scope.deregisterListener();
                    });
                });

                common.ionicPopupHandler(popupPromise, 3000);
            }

            scope.$evalAsync(() => {
                disableshowOwnedEvents();

                if (UserService.langCode === 'en-GB') {
                    pickedDate.locale('en');
                    scope.setSearchDateValues(pickedDate.clone(), pickedDate.format('L'), 'on ' + pickedDate.format('dddd').ucfirst());
                }
                else if (UserService.langCode === 'sv-SE') {
                    pickedDate.locale('sv');
                    scope.setSearchDateValues(pickedDate.clone(), pickedDate.format('L'), 'på ' + pickedDate.format('dddd').ucfirst());
                }
                else if (UserService.langCode === 'de-DE') {
                    pickedDate.locale('de');
                    scope.setSearchDateValues(pickedDate.clone(), pickedDate.format('L'), pickedDate.format('dddd').ucfirst());
                }                
                else {
                    pickedDate.locale('fi');
                    scope.setSearchDateValues(pickedDate.clone(), pickedDate.format('L'), pickedDate.format('dddd').ucfirst() + 'na');
                }

                if (FitnessService.fitnessCategories.length) {
                    for (let index of FitnessService.fitnessCategories.keys()) {
                        scope.pageContent[index] = scope.createContent(index, false);
                    }
                }
            });
        };

        if (dateInput === true) { //Show all.
            disableshowOwnedEvents();

            scope.setSearchDateValues();

            scope.$evalAsync(() => {
                scope.pageContent = angular.copy(scope.fullPageContent);
            });
        }
        else if (dateInput) { //Deal with picked date
            handleInputMoment(dateInput);
		}
        else { //Error?
            openPopupCalendar().then((res) => {
                if (res)
                    handleInputMoment(res);

                scope.calendarPopupResolve = null;
                scope.deregisterListener();
            });
		}
    };

    scope.showOwnedEvents = () => {
        if (scope.showOwnedEventsOnly) //Skip if already this state
            return;

        scope.showOwnedEventsOnly = true;

        if (FitnessService.fitnessCategories.length) {
            for (let index of FitnessService.fitnessCategories.keys()) {
                scope.fullPageContent[index] = scope.createContent(index, true); //Skip date comp
                scope.pageContent[index] = scope.createContent(index, true); //Skip date comp
            }
        }
    };

    scope.clickedEvent = (clickedActivityId) => {
		state.go('app.showevent', { activityId: clickedActivityId });
		return;

        //The below does not open showEvents, but just shows popup if event is full.
        const event = FitnessService.fitnessEvents.find((event) => event.activityId === clickedActivityId);
        const isPersonInAttendance = event.eventAttendees && event.eventAttendees.findIndex((attendee) => attendee.personId === UserService.user.personId) > -1;

        if (event.totalCapacity !== 0 && event.totalAttendeeQuantity >= event.totalCapacity && !isPersonInAttendance) {
            const popupPromise = ionicPopup.alert({
                title: _locale('event is full').ucfirst(),
                template: _locale('there are no more vacancies at this event').ucfirst(),
                cssClass: 'bigger-popup',
            });

            common.ionicPopupHandler(popupPromise, 3000);
        }
        else
            state.go('app.showevent', { activityId: clickedActivityId });
    };

    scope.getFitnessData = (refresh) => {
        console.log(`[${performance.now()}] Calling FitnessService.getFitnessData() from FitnessCrtl.scope.getFitnessData()`);

        FitnessService.getFitnessData().then(() => {
            if (refresh)
                scope.$broadcast('scroll.refreshComplete');
        });
    };
}

FitnessCtrl.$inject = $inject

export default FitnessCtrl